import React from 'react';
import CurationCardSkeleton from './CurationCardSkeleton';

/**
 * 큐레이션 섹션 전체 스켈레톤 컴포넌트
 * 실제 CurationSection과 동일한 구조로 스켈레톤 생성
 */
const CurationSkeleton: React.FC = () => {
  return (
    <div className="md-spacing-1">
      {/* 구분선 (CategorySection과 동일) */}
      <div className="mx-4 mb-6 border-t border-gray-200"></div>
      
      {/* 큐레이션 카드들 스켈레톤 (3개 카테고리) */}
      <div>
        <CurationCardSkeleton />
        <CurationCardSkeleton />
        <CurationCardSkeleton />
      </div>
    </div>
  );
};

export default CurationSkeleton; 